
import { defineComponent } from 'vue'


export default defineComponent({
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    components: {},
    setup(props, { emit }) {
        const update = (val: string) => {
            emit('input', Object.assign({}, props.value, { text: val }))
        }

        return { update }
    },
})
